<template>
    <div class="container_layout">
        <el-row class="guide_title">
            <el-col :span="16" :offset="4">請選擇走期天數？</el-col>
        </el-row>

        <el-row style="margin-top:40px;text-align:center;">
            <el-col :xs="2" :sm="4" :md="4">
                &nbsp; <!-- RWD offset -->
            </el-col>
            <el-col :xs="20" :sm="16" :md="16"  class="">
                <div class="datepicker-trigger">
                    <input
                            type="text"
                            id="datepicker-trigger"
                            placeholder="請選擇日期範圍"
                            :value="formattedDates"
                    >
                    <AirbnbStyleDatepicker
                            :trigger-element-id="'datepicker-trigger'"
                            :mode="'range'"
                            :fullscreen-mobile="false"
                            :months-to-show="2"
                            :inline="true"
                            :minDate="today"
                            :endDate="dateOnePlus90Days"
                            :date-one="dateOne"
                            :date-two="dateTwo"
                            @date-one-selected="val => { onDateUpdate('dateOne', val) }"
                            @date-two-selected="val => { onDateUpdate('dateTwo', val) }"
                    />
                </div>

                <div class="guide_range_total" style="">*已選擇 {{duration}} 天  </div>
            </el-col>
        </el-row>
    </div>
</template>

<script>
import { mapState } from 'vuex'
import { GUIDE_MUTATIONS } from '../../../store/modules/guide'
import format from 'date-fns/format'

// 常數
const DATE_FORMAT_FOR_CALENDAR_COMPONENT = 'YYYY-MM-DD'
const DATE_FORMAT_FOR_DISPLAY = 'YYYY/M/D'

export default {
  name: 'step4',
  props: ['path'],
  computed: {
    ...mapState({
      duration: state => state.guide.purpose.duration
    }),
    today () {
      return format(new Date(), DATE_FORMAT_FOR_CALENDAR_COMPONENT)
    },
    dateOnePlus90Days () {
      const dateLimit = new Date(this.dateOne) * 1 + (1000 * 60 * 60 * 24) * 89
      return format(dateLimit, DATE_FORMAT_FOR_CALENDAR_COMPONENT)
    },
    dateOne: {
      get () {
        return this.schedule && this.schedule[0] ? this.schedule[0] : ''
      },
      set (val) {
        this.onDateUpdate('dateOne', val)
      }
    },
    dateTwo: {
      get () {
        return this.schedule && this.schedule[1] ? this.schedule[1] : ''
      },
      set (val) {
        this.onDateUpdate('dateTwo', val)
      }
    },
    schedule: {
      get () {
        return this.$store.state.guide.purpose.schedule
      },
      set (val) {
        this.$store.commit(GUIDE_MUTATIONS.PURPOSE.SET_SCHEDULE, val)
      }
    },
    formattedDates () {
      let result = ''
      if (this.dateOne) {
        result = format(this.dateOne, DATE_FORMAT_FOR_DISPLAY)
      }
      if (this.dateTwo) {
        result += ' - ' + format(this.dateTwo, DATE_FORMAT_FOR_DISPLAY)
      }
      return result
    }
  },
  methods: {
    onDateUpdate (dateName, val) {
      const tmpSchedule = this.$lodash.cloneDeep(this.schedule)
      switch (dateName) {
        case 'dateOne':
          tmpSchedule[0] = val
          break
        case 'dateTwo':
          tmpSchedule[1] = val
          break
      }
      this.$store.commit(GUIDE_MUTATIONS.PURPOSE.SET_SCHEDULE, tmpSchedule)
    }
  }
}
</script>
<style >
    .asd__wrapper{
        margin:0 auto;

    }
    .asd__keyboard-shortcuts-trigger-wrapper,.asd__action-buttons{
        display:none;
    }
    .datepicker-open{
        padding:3px 10px;
        line-height: 1.5;
        text-align: center;
        margin-bottom: 4px;
        color:#4a4a4a;
        background:transparent;

        border:0;
        color: rgb(77, 161, 255);
        font-size: 18px;
        font-weight: bold;
    }
    .guide_range_total{
        color: #4da1ff;
        font-size: 18px;
        font-weight: bold;
        margin-top: 16px;margin-left:-8px;
    }
</style>
